import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
import { ApiResponse, LatLng, PartnersLocation, TransporterProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { ITransporterService } from '../iTransporterService';

export class TransporterService implements ITransporterService {
    public async getTransporterList(baseURL: string, transporterRequest: QueryRecordsRequest):
    Promise<ApiResponse<TransporterProfile[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: transporterRequest.conditions ? transporterRequest.conditions : [],
            limit: transporterRequest.limit  ? transporterRequest.limit : MedTransGoConstants.PAGINATION_LIMIT,
            start: transporterRequest.start ? transporterRequest.start : 0,
        };
        const apiRequest: ApiRequest = {
            baseURL,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<TransporterProfile[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }
    public async getPartnersLocation(baseURL: string):
    Promise<ApiResponse<PartnersLocation>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PARTNERS}/locations`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<PartnersLocation>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }
}
